import { Component, OnInit } from '@angular/core';

import { environment } from '@environments/environment';

@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss'],
  standalone: false,
})
export class AppLayoutComponent implements OnInit {
  constructor() {}

  // TODO: Remove ngOnInit if not needed in future review
  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit(): void {}
}
